import React from "react";
import { RxCross2 } from "react-icons/rx";
import { IoIosInformationCircle } from "react-icons/io";

const UploadImageSection = ({
  removeFile,
  setUploadImageHover,
  handleFileChange,
  uploadImageHover,
  editedPost,
  files,
  setFieldValue,
  errors,
  touched,
  setTouched,
  editable,
  isCarousal,
  isReel,
  setIsReel,
  isStory,
  setIsStory,
}) => {
  // Count uploaded videos
  const videoCount =
    files?.filter((file) => {
      if (typeof file === "string") {
        return file.match(/\.(mp4)$/i);
      }
      return file?.type?.startsWith("video");
    }).length || 0;

  // Determine when to show Post as Reel and Attach Thumbnail
  const showReelOptions = videoCount > 0 && videoCount < 2;

  return (
    <div className="flex transition-all flex-col gap-2">
      <h1 className="font-bold flex gap-2 items-center text-sm">
        Add Images and Videos{" "}
        <IoIosInformationCircle className="text-[#007aff]" />
      </h1>

      <div className="flex gap-4 flex-wrap">
        {files?.length ? (
          files.map((file, index) => {
            const isString = typeof file === "string";
            const fileUrl = isString ? file : URL.createObjectURL(file);
            const isImage = isString
              ? fileUrl.match(/\.(jpeg|jpg|png|webp)$/i)
              : file?.type?.startsWith("image");
            return (
              <div
                key={index}
                className="relative w-64 h-64 flex flex-col items-center justify-center border-2 border-gray-200 rounded-lg bg-gray-50 shadow-md"
              >
                <div className="w-full rounded h-full relative">
                  {isImage ? (
                    <img
                      src={fileUrl}
                      alt="preview"
                      className="w-full h-full rounded object-center"
                    />
                  ) : (
                    <video
                      src={fileUrl}
                      controls
                      className="w-full h-full rounded object-center"
                    />
                  )}
                  <button
                    onClick={() => removeFile(index)}
                    disabled={!editable}
                    className="absolute -top-2 -right-2 cursor-pointer bg-blue-400 hover:bg-slate-100 hover:font-bold hover:text-lg hover:text-opacity-1 transition-all ease-in-out duration-700 hover:text-red-500 hover:text-opacity-50 text-white p-1 rounded-full text-sm"
                  >
                    <RxCross2 />
                  </button>
                </div>
              </div>
            );
          })
        ) : (
          <></>
          // <div className="relative w-64 h-64 flex flex-col items-center justify-center border-2 border-gray-200 rounded-lg bg-gray-50 shadow-md overflow-hidden">
          //   <p className="text-gray-400 text-center">No file uploaded</p>
          // </div>
        )}

        {/* Upload Section */}
        {editable && !isReel && (
          <label
            onMouseEnter={() => setUploadImageHover(true)}
            onMouseLeave={() => setUploadImageHover(false)}
            className="w-64 h-64 hover:border-[#007aff] transition-all ease-in-out duration-700 hover:-translate-y-1 hover:bg-[#E6F7FF] hover:shadow-[#E6F7FF] flex flex-col items-center justify-center border-2 border-gray-200 rounded-lg bg-gray-50 shadow-md cursor-pointer"
          >
            <input
              disabled={files?.length == 1 && !isCarousal}
              type="file"
              accept="image/*, video/*"
              className="hidden"
              multiple={isCarousal}
              onChange={(event) => handleFileChange(event, setFieldValue)}
            />
            <div
              className={`w-16 h-16 flex border-[2px] items-center justify-center transition-all duration-700 ease-in-out ${
                uploadImageHover
                  ? "bg-white border-[#007aff] border-opacity-20"
                  : "bg-blue-400"
              } rounded-lg`}
              onClick={() => {
                setTouched({ uploadFileArr: true });
              }}
            >
              <span
                className={`transition-all duration-700 ease-in-out ${
                  uploadImageHover ? "text-[#007aff]" : "text-white"
                } text-2xl`}
              >
                +
              </span>
            </div>
            <p className="mt-2 text-gray-600 font-medium text-center">
              {files?.length == 1 && !isCarousal
                ? "Use carousal for more uploads."
                : "Add a new Image/Video"}
            </p>
            <p className="text-sm text-gray-400 text-center">
              (jpg, jpeg, png & Webp, MP4)
            </p>
          </label>
        )}
      </div>

      {touched.uploadFileArr && errors.uploadFileArr && (
        <p className="text-red-500 text-xs mt-1">{errors.uploadFileArr}</p>
      )}

      <div className="text-xs flex items-center gap-2 mt-2 justify-start">
        <label className="flex items-center space-x-2">
          <input
            disabled={!editable}
            type="checkbox"
            name="postStory"
            checked={isStory === "story"}
            onChange={(e) =>
              setIsStory(e.target.checked === true ? "story" : null)
            }
            className="form-checkbox text-blue-500 w-3 h-3"
          />
          <span className="text-xs text-gray-500 whitespace-nowrap">
            Post as Story
          </span>
        </label>

        {showReelOptions && (
          <>
            <label className="flex items-center space-x-2">
              <input
                disabled={!editable}
                type="checkbox"
                name="postReel"
                checked={isReel === "reel"}
                onChange={(e) => {
                  setIsReel(e.target.checked === true ? "reel" : null);
                }}
                className="form-checkbox text-blue-500 w-3 h-3"
              />
              <span className="text-xs text-gray-500 whitespace-nowrap">
                Post as Reel
              </span>
            </label>

            <label className="relative bg-blue-500 text-white px-6 py-2 rounded cursor-pointer">
              Attach Thumbnail
              <input
                type="file"
                accept="image/*"
                className="hidden"
                disabled={!editable}
                // Implement onChange if needed
              />
            </label>
          </>
        )}
      </div>
    </div>
  );
};

export default UploadImageSection;
